import PostListItem from '@/pages/profile/board/components/PostListItem';
import CommunityArticleCard from '@/shared-components/cards/components/CommunityArticleCard';
import CommunityArtlistCard from '@/shared-components/cards/components/CommunityArtlistCard';
import CommunityNotRatedCard from '@/shared-components/cards/components/CommunityNotRatedCard';
import CommunityRatingCard from '@/shared-components/cards/components/CommunityRatingCard';
import CommunityThoughtCard from '@/shared-components/cards/components/CommunityThoughtCard';
import NewArtworkCard from '@/shared-components/cards/components/NewArtworkCard';

export default function CommunityFeedItem({ item }) {
  switch (item.kind) {
  case 'post':
    return <PostListItem data={item.data} />;

  case 'article':
    return <CommunityArticleCard article={item.article} actor={item.actor} />;

  case 'thought':
    return <CommunityThoughtCard data={item.data} actor={item.actor} />;

  case 'rating':
    return <CommunityRatingCard data={item.data} actor={item.actor} />;

  case 'rating-prompt':
    return (
      <CommunityNotRatedCard
        data={item.data}
        actor={item.actor}
      />
    );

  case 'artlist':
    return (
      <CommunityArtlistCard
        artlist={item.artlist}
        createdAt={item.createdAt}
        actor={item.actor}
      />
    );

  case 'artwork':
    return <NewArtworkCard data={item.artwork} actor={item.actor} />;

  default:
    return null;
  }
}
